import logger from '../logger';
import { getExtendedProperties } from './index';
import { PROFILES_TOUCH_ADD_INSURANCE } from './events';

const ITERABLE_TRACKABLE_EVENTS = [PROFILES_TOUCH_ADD_INSURANCE];

const isEventWhiteListedForIterable = eventName => ITERABLE_TRACKABLE_EVENTS.includes(eventName);

export const analyticsTrackEventOnlyToIterableViaSegment = (event, properties) => {
  if (window.analytics) {
    if (isEventWhiteListedForIterable(event)) {
      const segmentOptions = {
        integrations: {
          All: false,
          Iterable: true,
        },
      };
      window.analytics.track(event, getExtendedProperties(properties, event), segmentOptions);
    }
  } else {
    logger.warn('Track event Analytics not loaded');
  }
};
